import { CrosswordInput } from '../types';
import crosswordsFile from './crosswordsShuffled.json';
import crosswords7File from './crosswords7.json';
import { GameMode } from '../lib/gameMode';

export const classicCrosswords: CrosswordInput[] = crosswordsFile as unknown as CrosswordInput[];
export const largeCrosswords: CrosswordInput[] = crosswords7File as unknown as CrosswordInput[];

export function getPuzzleBank(mode: GameMode): CrosswordInput[] {
  return mode === 'large' ? largeCrosswords : classicCrosswords;
}

const crosswords = classicCrosswords;
export default crosswords;
